module.exports = "<c4-input-float\n\t[config]=\"config\"\n\t[name]=\"name\"\n\t[precision]=\"precision\"\n\t[min]=\"min\"\n\t[max]=\"max\"\n\t[readonly]=\"readonly\"\n\t[prefix]=\"prefix\"\n\t[suffix]=\"suffix\"\n\t[value]=\"value\"\n\t(valueChange)=\"valueChange.next($event)\">\n</c4-input-float>"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/ui/src/app/directives/input/integer/c4-input-integer.html
// module id = 1643
// module chunks = 2